var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { t } from '../../../strings/i18n/i18n';
import { getLanguageFromStorage } from 'syf-js-utilities';
import { formatDisputeDetails } from '../Accordion/helpers';
export var formatDispute = function (transactions, dispute) {
    var _a;
    var disputeTransactions = (_a = dispute.transactions) === null || _a === void 0 ? void 0 : _a.map(function (transaction) { return ({
        caseId: dispute.caseId,
        disputeReason: transaction.disputeReason,
        postedDate: transaction.requestCreationDate,
        description: transaction.merchantName,
        amount: transaction.amountInDispute,
        details: formatDisputeDetails(transaction),
        statusCode: transaction.statusCode,
        isCancelSubmitted: transaction.isCancelSubmitted,
        transactionId: transaction.id
    }); });
    return __spreadArray(__spreadArray([], transactions, true), disputeTransactions, true);
};
export var sortFunction = function (sorter, sortOrder) {
    var sorterFunctions = {
        postedDate: function (a, b) {
            if (b.postedDate < a.postedDate) {
                return -1 * sortOrder;
            }
            if (b.postedDate > a.postedDate) {
                return 1 * sortOrder;
            }
            return 0;
        },
        amount: function (a, b) {
            if (Number(b[sorter]) < Number(a[sorter])) {
                return -1 * sortOrder;
            }
            if (Number(b[sorter]) > Number(a[sorter])) {
                return 1 * sortOrder;
            }
            return 0;
        },
        claimId: function (a, b) {
            if (Number(b.caseId) < Number(a.caseId)) {
                return -1 * sortOrder;
            }
            if (Number(b.caseId) > Number(a.caseId)) {
                return 1 * sortOrder;
            }
            return 0;
        }
    };
    return sorterFunctions[sorter];
};
export var translations = {
    en: ['descending', 'ascending'],
    es: ['descendente', 'ascendente']
};
export var renderSortByText = function (sorter, sortOrder) {
    var language = getLanguageFromStorage();
    var sorterTranslation = t("sorter.".concat(sorter), { lng: language })
        .replace(/([a-z](?=[A-Z]))/g, '$1 ')
        .toLowerCase();
    return t('sorter.sortedByText', {
        type: sorterTranslation,
        direction: translations[language][sortOrder === 1 ? 1 : 0],
        lng: language
    });
};
//# sourceMappingURL=helpers.js.map